import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How is Artreal different from stock photo mockups?',
    answer: 'Artreal generates unique AI rooms specifically around YOUR artwork. Every mockup is fresh and custom-made, not a reused stock photo. This means your listings stand out and buyers see your art in realistic, varied settings.'
  }, {
    question: 'Can I use these mockups for commercial purposes?',
    answer: 'Yes! All mockups generated with Artreal are 100% yours to use commercially. Use them on Etsy, your website, social media, print materials, or anywhere else you sell your art.'
  }, {
    question: 'What file formats do you support?',
    answer: 'Artreal works with JPG, PNG, and PDF files. We recommend uploading high-resolution artwork (at least 2000px on the longest side) for best results. The app will automatically optimize your mockups for web and print.'
  }, {
    question: 'How does the AI listing copy work?',
    answer: 'Our AI analyzes your artwork and the generated mockup to create SEO-optimized Etsy titles and descriptions. It understands art styles, colors, and room contexts to write compelling copy that converts. You can edit the output before using it.'
  }, {
    question: 'Can I cancel my subscription anytime?',
    answer: 'Absolutely. You can cancel your subscription at any time from your account settings. Your access will continue until the end of your billing period, and you can always resubscribe later.'
  }, {
    question: 'Do you offer refunds?',
    answer: "We offer a 7-day money-back guarantee on all paid plans. If you're not satisfied within the first 7 days, contact support for a full refund."
  }];
  return <section className="w-full bg-gradient-to-b from-[#1A1A2E] to-[#0A0A0F] py-24 lg:py-32" data-id="element-21">
      <div className="max-w-4xl mx-auto px-6" data-id="element-22">
        <div className="text-center mb-16" data-id="element-23">
          <span className="text-sm font-bold text-[#3B9EFF] tracking-widest uppercase" data-id="element-24">
            FAQ
          </span>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white mt-4 leading-tight tracking-tight" data-id="element-25">
            Questions? Answered.
          </h2>
        </div>

        <div className="space-y-4" data-id="element-26">
          {faqs.map((faq, index) => <div key={index} className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden hover:bg-white/10 transition-all duration-200" data-id="element-27">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left" data-id="element-28">
                <span className="font-bold text-white text-lg pr-8" data-id="element-29">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-[#3B9EFF] flex-shrink-0 transition-transform duration-200 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-30" />
              </button>

              {openIndex === index && <div className="px-6 pb-5" data-id="element-31">
                  <p className="text-gray-400 leading-relaxed" data-id="element-32">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}